export const getPlainTextFromHtml = (html?: string | null): string => {
  if (!html) return '';

  if (typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  }

  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const isRichTextMeaningful = (html?: string | null, minLength = 1): boolean =>
  getPlainTextFromHtml(html).length >= minLength;
